import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { IAPComponentStateModel } from '../../../../../global/models/ap_component_state_model';
import { IFeedbackTermAndSuggestion } from '../../builders/plan_feedback_transaction_builder';
import { FeedbackSuggestedPlanModel } from '../../models/feedback_suggested_plan_model';
import {
  ApPlanFeedbackDeEmphasizeEventNameStrategy,
  ApPlanFeedbackEmphasizeEventNameStrategy
} from '../../strategies/plan_feedback_highlight_event_name_strategy';

class PlanFeedbackTermContainer {
  private termAndSuggestions: IFeedbackTermAndSuggestion;
  private suggestionHidden: boolean = false;

  constructor(
    private acceptDeclinePlanFeedbacksCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private $element: ng.IAugmentedJQuery,
    private ngAPComponentStateModel: IAPComponentStateModel,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
    private performActionOnFeedbackHelper: ng.IServiceProviderFactory
  ) {}

  $onInit() {
    const termId = this.termAndSuggestions.id;
    if (!this.ngAPComponentStateModel.studentFeedbackTerms[termId]) {
      this.updateComponentState(termId, false);
    }
    this.suggestionHidden = _4.get(this.ngAPComponentStateModel, `studentFeedbackTerms[${termId}].opened`, false);
  }

  updateComponentState(termId: any, state: boolean) {
    if (!this.ngAPComponentStateModel.studentFeedbackTerms[termId]) {
      this.ngAPComponentStateModel.studentFeedbackTerms[termId] = {
        opened: state,
        termId
      };
    } else {
      this.ngAPComponentStateModel.studentFeedbackTerms[termId].opened = state;
    }
  }

  emphasizeSuggestionsTileInTerm() {
    this.$element.find('.plan-feedback-term-container').addClass('ap-plan-feedback-hover-class');
    this.termAndSuggestions.suggestions.forEach((suggestion) =>
      this.ngComponentCommunicatorService.publish(
        ApPlanFeedbackEmphasizeEventNameStrategy[suggestion.type](suggestion.transactionNK)
      )
    );
  }
  deEmphasizeSuggestionsTileInTerm() {
    this.$element.find('.plan-feedback-term-container').removeClass('ap-plan-feedback-hover-class');
    this.termAndSuggestions.suggestions.forEach((suggestion) =>
      this.ngComponentCommunicatorService.publish(
        ApPlanFeedbackDeEmphasizeEventNameStrategy[suggestion.type](suggestion.transactionNK)
      )
    );
  }

  toggleSuggestions() {
    const termId = this.termAndSuggestions.id;
    this.updateComponentState(termId, !this.suggestionHidden);
    this.suggestionHidden = _4.get(this.ngAPComponentStateModel, `studentFeedbackTerms[${termId}].opened`, false);
  }

  acceptAllSuggestions() {
    this.performActionOnFeedbackHelper(
      this.termAndSuggestions.suggestions,
      'ACCEPT',
      [this.termAndSuggestions.nk],
      'TERM'
    );
  }
}

angular.module('capability-ng-academic-planner').component('planFeedbackTermContainer', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term_container/plan_feedback_term_container.html',
  controller: PlanFeedbackTermContainer,
  bindings: {
    termAndSuggestions: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_term_container/plan_feedback_term_container.ts